"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateProjectVersion;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
function updateProjectVersion(project, action) {
  // @todo: validate updateTimestamp is iso date and that updateTimestamp is greater than current lastModifiedAt
  const newProject = (0, lodash_clonedeep_1.default)(project);
  newProject.lastModifiedAt = action.timestamp;
  if (!newProject.versionStack) {
    newProject.versionStack = [newProject.version];
  }
  if (!newProject.versionHistory) {
    newProject.versionHistory = [newProject.version];
  }
  const versionIdx = newProject.versionStack.indexOf(newProject.version);
  const newVersion = newProject.versionStack[newProject.versionStack.length - 1] + 1;
  newProject.version = newVersion;
  newProject.versionStack = [...newProject.versionStack.slice(0, versionIdx + 1), newVersion];
  newProject.versionHistory.push(newVersion);
  newProject.versionAction = action;
  newProject.preventUndoByUser = !!action.preventUndoByUser;
  return newProject;
}